import pino from 'pino';
import { env } from '@/shared/config/env';

/**
 * Structured frontend logger. Emits JSON-shaped log records to console in dev
 * and to console.* in production (where Sentry already captures errors).
 *
 * Always pass an object as the first arg for structured fields:
 *   logger.info({ event: 'auth.login', userId }, 'login success')
 */
export const logger = pino({
  level: env.logLevel,
  base: {
    app: 'cc-admin',
    appVersion: env.appVersion,
    environment: env.sentryEnvironment,
  },
  browser: {
    asObject: true,
    write: {
      info: (obj) => console.info('[cc-admin]', obj),
      debug: (obj) => console.debug('[cc-admin]', obj),
      warn: (obj) => console.warn('[cc-admin]', obj),
      error: (obj) => console.error('[cc-admin]', obj),
      fatal: (obj) => console.error('[cc-admin]', obj),
      trace: (obj) => console.trace('[cc-admin]', obj),
    },
  },
});

export type Logger = typeof logger;
